import { Moon, Sun } from 'lucide-react';
import { cn } from '@/lib/utils';
import { useTheme } from '@/components/theme/ThemeProvider';

/**
 * RAD Finance — ThemeToggle
 * --------------------------------------------------------------------------
 * Botão que alterna dark/light. A animação (cross-fade + rotação dos ícones
 * sol/lua) é feita só com CSS/Tailwind — sem framer-motion. O ícone visível
 * é controlado por opacity/rotate via classes condicionadas ao tema atual.
 */
export function ThemeToggle({ className }: { className?: string }) {
  const { theme, toggle } = useTheme();
  const isDark = theme === 'dark';
  const label = isDark ? 'Mudar para tema claro' : 'Mudar para tema escuro';

  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={label}
      title={label}
      className={cn(
        'relative inline-flex h-9 w-9 items-center justify-center rounded-md',
        'text-subtle hover:text-fg hover:bg-surface-2',
        'transition-colors duration-fast ease-rad',
        'focus:outline-none focus-visible:shadow-rad-focus',
        className,
      )}
    >
      <Sun
        className={cn(
          'absolute h-4 w-4 transition-all duration-300 ease-rad',
          isDark ? 'rotate-90 scale-0 opacity-0' : 'rotate-0 scale-100 opacity-100',
        )}
        aria-hidden
      />
      <Moon
        className={cn(
          'absolute h-4 w-4 transition-all duration-300 ease-rad',
          isDark ? 'rotate-0 scale-100 opacity-100' : '-rotate-90 scale-0 opacity-0',
        )}
        aria-hidden
      />
    </button>
  );
}
